// material-ui
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';

// third-party
import { useNavigate } from 'react-router-dom';

// assets
import SettingOutlined from '@ant-design/icons/SettingOutlined';

// ==============================|| HEADER PROFILE - SETTING TAB ||============================== //

// Support/Feedback used to link out to the paid template vendor's support site
// (codedthemes.support-hub.io) - irrelevant to Nexafarm, removed. Privacy
// Center/History were unwired placeholders with no backing feature.
export default function SettingTab() {
  const navigate = useNavigate();

  return (
    <List component="nav" sx={{ p: 0, '& .MuiListItemIcon-root': { minWidth: 32 } }}>
      <ListItemButton onClick={() => navigate('/settings')}>
        <ListItemIcon>
          <SettingOutlined />
        </ListItemIcon>
        <ListItemText primary="Platform Settings" />
      </ListItemButton>
    </List>
  );
}
